<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template>

        <t-input v-model="form.typeCriticalityId" hidden/>

        <t-input v-model="form.name" :add-error="error.name" label="Tipo de Criticidade" required/>

        <t-input v-model="form.degree" :add-error="error.degree" number required label="Grau de Risco"
                 small="Utilize a escala de sua preferência, exemplo de 1 a 5."/>

        <t-input v-model="form.color" required color-reduced label="Cor Texto Padrão"
                 small="Utilizado na maioria dos casos, onde é exibido somente o texto"/>


        <t-input v-model="form.textColor" required color-reduced label="Cor Destaques - Fundo"
                 small="Utilizado em relatórios, onde é destacado a criticidade, sendo esta a cor do fundo. Geralmente será a mesma 'Cor Texto Padrão'"/>

        <t-input v-model="form.backgroundColor" required color-sketch label="Cor Destaques - Texto"
                 small="Utilizado em relatórios, onde é destacado a criticidade, sendo esta a cor do texto para o destaque. Caso a cor do fundo for escura utilize a cor branca, caso for clara, utilize a cor preta por exemplo."/>


        <t-input v-model="form.class" select-colors :options="classOptions"
                 small="Deixe em branco para nenhuma cor fora do padrão, utilizada nas listagens do sistema para dar enfâse de acordo com a criticidade"
                 label="Cor da Linha"
        />

        <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

        <t-input-status v-model="form.status"/>

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'TypeCriticalityForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "typeCriticalityId",
      form: {
        typeCriticalityId: 0,
        typeCriticalityNumber: 0,
        name: "",
        note: "",
        color: "#000000",
        class: "",
        degree: 1,
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        degree: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      classOptions: [
        {value: "", text: "Padrão", appendage: ""},
        {value: "bg-light", text: "Cinza", appendage: "#ABB8C3"},
        {value: "bg-warning-light", text: "Amarela", appendage: "#FCB900"},
        {value: "bg-danger-light", text: "Vermelha", appendage: "#EB144C"},
      ]
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

